/** @jsx jsx */
import { jsx, css } from "@emotion/core"

import CategoryBlob from "./CategoryBlob"

const CategoriesContainer = ({ categories }) => {
  return (
    <header
      css={css`
        display: flex;
        align-items: center;
      `}
    >
      <h1
        css={css`
          margin: 0;
        `}
      >
        Categorías:
      </h1>
      <ul
        css={css`
          display: flex;
          align-items: center;
        `}
      >
        {categories.map(categoryItem => (
          <li>
            <CategoryBlob category={categoryItem} />
          </li>
        ))}
      </ul>
    </header>
  )
}

export default CategoriesContainer
